import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {UserService} from './user.service';
import {Globals} from '../globals';
import {Observable} from 'rxjs';
import {DataPatientCaseEndoRecallModel} from '../modules/recall/models/data-patient-case-endo-recall.model';
import {PatientCaseEndoRecallAutofillModel} from "../modules/recall/models/patient-case-endo-recall-autofill.model";
import {PatientCaseEndoRecallAutofillDetailModel} from "../modules/recall/models/patient-case-endo-recall-autofill-detail.model";
import {EndoRecallFormGetFinalReportDetails} from '../modules/recall/models/endo-recall-form-get-final-report-details';

@Injectable({
  providedIn: 'root'
})
export class RecallService {

  constructor(private http: HttpClient) { }

  getRecalls(patientCaseID: string): Observable<DataPatientCaseEndoRecallModel[]> {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'text/plain'})
    };
    return this.http.get<DataPatientCaseEndoRecallModel[]>(`api/recalls/get-recallsV2/${patientCaseID}`, httpOptions);
  }

  saveRecalls(recalls: DataPatientCaseEndoRecallModel[]): Observable<DataPatientCaseEndoRecallModel[]> {
    return this.http.post<DataPatientCaseEndoRecallModel[]>('api/recalls/save-recalls', recalls);
  }

  createNewRecall(LOCID: number, PatientId: string, PatientCaseId: string, CaseWorkItemFormsId: string, formattedDate: string, recall: DataPatientCaseEndoRecallModel): Observable<DataPatientCaseEndoRecallModel> {
    return this.http.post<DataPatientCaseEndoRecallModel>(`api/recalls/create-new-recall/${LOCID}/${PatientId}/${PatientCaseId}/${CaseWorkItemFormsId}/${formattedDate}`, recall);
  }

  getParentPatientCaseID(PatientCaseId: string): Observable<string> {
    return this.http.get<string>(`api/recalls/get-parent-patientcaseid/${PatientCaseId}`);
  }

  deleteRecall(recall: DataPatientCaseEndoRecallModel): Observable<DataPatientCaseEndoRecallModel> {
    return this.http.post<DataPatientCaseEndoRecallModel>('api/recalls/delete-recall', recall);
  }

  getAutoFills(): Observable<PatientCaseEndoRecallAutofillModel[]> {
    return this.http.get<PatientCaseEndoRecallAutofillModel[]>('api/recalls/get-autofills');
  }

  getAutoFillDetail(AutoFillID: string): Observable<PatientCaseEndoRecallAutofillDetailModel> {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'text/plain'})
    };
    return this.http.get<PatientCaseEndoRecallAutofillDetailModel>(`api/recalls/get-autofill-detail${AutoFillID}`, httpOptions);
  }

  saveAutoFill(autofill: PatientCaseEndoRecallAutofillModel): Observable<PatientCaseEndoRecallAutofillModel> {
    return this.http.post<PatientCaseEndoRecallAutofillModel>('api/recalls/save-autofill', autofill);
  }

  saveAutoFillDetail(detail: PatientCaseEndoRecallAutofillDetailModel): Observable<PatientCaseEndoRecallAutofillDetailModel> {
    return this.http.post<PatientCaseEndoRecallAutofillDetailModel>('api/recalls/save-autofill-detail', detail);
  }

  copy(target: string, source: string) {
    return this.http.get<DataPatientCaseEndoRecallModel>(`api/recalls/copy/${target}/${source}`);
  }

  getFinalReportData(CaseFinalReportID: string) {
    return this.http.get<EndoRecallFormGetFinalReportDetails>(`api/recalls/get-mti-finalreport-details/${CaseFinalReportID}`);
  }
}
